module.exports = {
  "/": {
    "success": {
      "index page loaded": [
        "LOGIN_LOAD"
      ]
    }
  },
  "/login": {
    "success": {
      "login page loaded": [
        "LOGIN_LOAD"
      ]
    }
  },
  "/sso": {
    "success": {
      "sso page loaded": [
        "SSO_LOAD"
      ]
    }
  },
  "/sso/acs": {
    "success": {
      "sso-acs page loaded": [
        "SSO_ACS_LOAD"
      ]
    },
    "error": [
      "SSO_ACS_ERROR"
    ]
  },
  "/sso/complete": {
    "success": {
      "sso-complete page loaded": [
        "SSO_COMPLETE_LOAD"
      ]
    },
    "error": [
      "SSO_COMPLETE_ERROR"
    ]
  },
  "/two-factor": {
    "success": {
      "two-factor page loaded": [
        "TWO_FACTOR_LOAD"
      ]
    }
  },
  "/two-factor/recovery": {
    "success": {
      "two-factor recovery page loading": [
        "TWO_FACTOR_RECOVERY_LOADING"
      ],
      "two-factor recovery page loaded": [
        "TWO_FACTOR_RECOVERY_LOAD"
      ]
    }
  },
  "/two-factor/support-recovery": {
    "success": {
      "two-factor support recovery page loaded": [
        "TWO_FACTOR_SUPPORT_RECOVERY_LOAD"
      ]
    }
  },
  "/two-factor/admin-recovery": {
    "success": {
      "two-factor admin recovery page loaded": [
        "TWO_FACTOR_ADMIN_RECOVERY_LOAD"
      ]
    }
  },
  "/two-factor/recovery-verify": {
    "success": {
      "two-factor recovery verify page loaded": [
        "TWO_FACTOR_RECOVERY_VERIFY_LOAD"
      ]
    }
  },
  "/confirm-to-login": {
    "success": {
      "c2l page loaded": [
        "CONFIRM_TO_LOGIN_LOAD"
      ]
    }
  },
  "/passwordReset": {
    "success": {
      "password reset page loaded": [
        "PASSWORD_RESET_LOAD"
      ]
    }
  },
  "/googleLoginRedirect": {
    "success": {
      "google login redirect page loaded": [
        "GOOGLE_LOGIN_REDIRECT_LOAD"
      ]
    }
  },
  "/trust-token": {
    "success": {
      "trust token page loaded": [
        "TRUST_TOKEN_LOAD"
      ]
    }
  },
  "/forgot": {
    "success": {
      "forgot password page loaded": [
        "FORGOT_LOAD"
      ],
      "email sent page loaded": [
        "EMAIL_SEND_SUCCESS"
      ]
    }
  },
  "/password-leak": {
    "success": {
      "password leaked page loaded": [
        "LOCKED_LOAD"
      ],
      "email sent page loaded": [
        "EMAIL_SEND_SUCCESS"
      ]
    }
  },
  "/suspicious-activity": {
    "success": {
      "suspicious activity page loaded": [
        "LOCKED_LOAD"
      ],
      "email sent page loaded": [
        "EMAIL_SEND_SUCCESS"
      ]
    }
  },
  "/idle-user": {
    "success": {
      "idle user page loaded": [
        "LOCKED_LOAD"
      ],
      "email sent page loaded": [
        "EMAIL_SEND_SUCCESS"
      ]
    }
  },
  "/update-password": {
    "success": {
      "update password page loaded": [
        "LOCKED_LOAD"
      ],
      "email sent page loaded": [
        "EMAIL_SEND_SUCCESS"
      ]
    }
  },
  "/beta": {
    "success": {
      "email entry page loaded": [
        "SL_EMAIL_ENTRY_SUCCESS"
      ]
    }
  },
  "/beta/select": {
    "success": {
      "select login page loaded": [
        "SL_SELECT_LOGIN_SUCCESS"
      ]
    }
  }
};